import React from "react"
import { useIntl } from 'react-intl'
import { FormSubGroup, Label } from '../../layout'

import { MultiValue, Option } from '../components/MultiValueSelect'
import { FilterSelect } from '../components/FilterSelect'
import { SelectContainer, useTowingJobFilterContext } from '../context'
import { towingJobFilterMessages } from '../messages'
import { formatMessageSafe } from '../../../util/translateInputOptions'

interface OptionType {
  label: string
  value: string
}

interface JobTypeOptionsProps {
  options: OptionType[]
}

export const JobTypeFilter = ({ options }: JobTypeOptionsProps) => {
  const { values, setValues } = useTowingJobFilterContext()
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const handleLabelChange = (selectedOptions: any) => {
    const selectedValues = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : []

    setValues({
      ...values,
      filters: {
        ...values.filters,
        labels: selectedValues,
      },
    })
  }

  return (
    <FormSubGroup>
      <Label>{formatMessage(towingJobFilterMessages.jobTypeLabel)}</Label>
      <SelectContainer>
        <FilterSelect
          isMulti
          isSearchable={false}
          placeholder={formatMessage(towingJobFilterMessages.selectPlaceholder)}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          options={options.map(option => ({ value: option.value, label: option.label }))}
          value={options
            .filter(option => values.filters.labels.includes(option.value))
            .map(option => ({ value: option.value, label: option.label }))}
          onChange={handleLabelChange}
          components={{ MultiValue, Option }}
          maxToShow={3}
        />
      </SelectContainer>
    </FormSubGroup>
  )
}